// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3933N","colCheckbox":"styles_colCheckbox__7dj71"};